import React, { useRef, useState } from 'react'

import { RowLayoutWithSticky, RowLayoutContent, Header } from 'app/common/layouts/RowLayout'
import Prompt from 'app/components/common/Prompt'
import { useLastChange } from 'app/dataProviders/OrgSettingsHistoryProvider'
import { ContentGroup } from 'app/common/templates-next/page-template'

import MultipleSubmitSettings from '../MultipleSubmitSettings'
import HistoryLink from '../HistoryLink'

import styles from './DietFood.module.scss'
import { MultipleModalAdditionalContent } from './MultipleModalAdditionalContent'
import { DietFoodTypes } from './DietFoodTypes'
import { OrgId } from 'app/dataTypes/org'

const header = "Диетическое питание"

type Props = {
  orgId: number
}

export const DietFood = ({ orgId }: Props) => {
  const [, updateLastChange] = useLastChange()
  const formRef = useRef(null)
  const [submitting, setSubmitting] = useState(false)

  const submit = () => true
  const checkErrors = () => false

  const modified = false


  return (
    <RowLayoutWithSticky
      number={3}
      content={
        <RowLayoutContent borderBottom className={styles.topbar}>
          <div>
            <Header>{header}</Header>
            <HistoryLink sectionTitle={header} />
          </div>
        </RowLayoutContent>
      }
    >
      <RowLayoutContent>
        <MultipleSubmitSettings
          additionalContent={<MultipleModalAdditionalContent />}
          onSubmitArray={submit}
          onChangeSubmitState={setSubmitting}
          onSuccess={updateLastChange}
          onShowModal={checkErrors}
          formId="dietFood_form"
        >
          {(toggleMultipleSubmitModal, multipleSubmit) => (
            <form onSubmit={multipleSubmit} ref={formRef} id="dietFood_form">

              {/* индивидуальные справки */}

              <ContentGroup
                header={
                  <span>
                    {'Настройки по '}
                    <strong>{'видам диетического питания'}</strong>
                  </span>
                }
              >
                <DietFoodTypes
                  orgId={orgId.toString() as OrgId}
                />
              </ContentGroup>

              <button type="submit" name="submit" className={styles.hidden}>
                {'Сохранить'}
              </button>
            </form>
          )}
        </MultipleSubmitSettings>

        <Prompt when={modified} message="Вы не сохранили изменения, перейти в любом случае?" />
      </RowLayoutContent>
    </RowLayoutWithSticky>
  )
}

